import { render, staticRenderFns } from "./DeleteModal.vue?vue&type=template&id=072a3e4a&"
import script from "./DeleteModal.vue?vue&type=script&lang=js&"
export * from "./DeleteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('072a3e4a')) {
      api.createRecord('072a3e4a', component.options)
    } else {
      api.reload('072a3e4a', component.options)
    }
    module.hot.accept("./DeleteModal.vue?vue&type=template&id=072a3e4a&", function () {
      api.rerender('072a3e4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/dahreply/DeleteModal.vue"
export default component.exports